import { render, staticRenderFns } from "./RegistrarPagamento.vue?vue&type=template&id=25364e43"
import script from "./RegistrarPagamento.vue?vue&type=script&lang=js"
export * from "./RegistrarPagamento.vue?vue&type=script&lang=js"
import style0 from "./RegistrarPagamento.vue?vue&type=style&index=0&id=25364e43&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports